import { recursiveAPI } from "services";
import useOffcanvasStore from "store/offcanvasStore";
import { formatMoney } from "utils";

function EachRtxn(props) {
  const { txn, triggertxns } = props;
  const { openOffcanvas } = useOffcanvasStore((state) => state);

  const handleEdit = (e) => {
    openOffcanvas("editRecursiveTxn", { editRcTxn: txn });
  };

  const handleDelete = () => {
    recursiveAPI.deleteRecursiveTxn(txn).then(() => {
      triggertxns();
    }).catch(console.log);
  };

  const handleEnable = () => {
    recursiveAPI.enableRecursiveTxn(txn.id).then(() => {
      triggertxns();
    }).catch(console.log);
  };

  const handleDisable = () => {
    recursiveAPI.disableRecursiveTxn(txn.id).then(() => {
      triggertxns();
    }).catch(console.log);
  };

  const formatInterval = (val) => {
    switch (val) {
      case 1: return "Daily";
      case 7: return "Weekly";
      case 30: return "Monthly (Same Date)";
      case 32: return "Monthly (1st Day)";
      case 33: return "Monthly (Last Day)";
      case 365: return "Annually";
      default: return `${val} days`;
    }
  };

  const borderStyle = {
    borderLeft: `5px solid ${txn.get("enabled") ?
      (txn.get("amount") > 0 ? "#3b7d17ff" : "#e63946ff")
      : "#b9b7b7ff"}`
  };

  return (
    <div className="col-12 mb-3">
      <div className="card border" >
        <div className="card-body p-3 rounded" style={borderStyle}>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div>
              <h5 className={`mb-0 fw-bold ${txn.get("amount") < 0 ? "text-danger" : "text-success"}`} style={{ letterSpacing: '-0.5px' }}>
                {formatMoney(Math.abs(txn.get("amount")))}
              </h5>
              <div className="d-flex align-items-center gap-2 mt-1">
                <span className="badge rounded-pill bg-light text-muted border-0 fw-normal small px-2">
                  {formatInterval(txn.get("interval"))}
                </span>
                {txn.get("enabled") ?
                  <span className="text-success small fw-medium d-flex align-items-center">
                    <span className="p-1 bg-success rounded-circle me-1 animate-pulse"></span> Active
                  </span>
                  :
                  <span className="text-secondary small fw-medium">Paused</span>
                }
              </div>
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input custom-switch"
                type="checkbox"
                checked={txn.get("enabled")}
                onChange={txn.get("enabled") ? handleDisable : handleEnable}
              />
            </div>
          </div>

          {txn.get("detail") && (
            <p className="text-secondary small mb-3 px-1" style={{ lineHeight: '1.4' }}>
              {txn.get("detail")}
            </p>
          )}

          <div className="bg-light rounded-4 p-2 d-flex justify-content-between align-items-center">
            <div className="ps-2">
              <span className="text-muted small d-block" style={{ fontSize: '0.7rem', fontWeight: '600', textTransform: 'uppercase' }}>Next Transaction</span>
              <span className="small fw-bold text-dark">{txn.get("nextTriggerDate")?.toLocaleDateString() || "Manual"}</span>
            </div>

            <div className="d-flex gap-1 pe-1">
              <button className="btn btn-white btn-sm shadow-sm rounded-3 border" onClick={handleEdit}>
                <i className="bi bi-pencil-fill small text-primary"></i>
              </button>
              <button className="btn btn-white btn-sm shadow-sm rounded-3 border" onClick={handleDelete}>
                <i className="bi bi-trash3-fill small text-danger"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

  );
}

export default EachRtxn;